<mat-toolbar
	fxLayout="row"
	fxLayoutAlign="space-between center"
	class="bar-background"
>
	<div fxLayout="row" fxLayoutAlign="center center">
		<button
			(click)="sidenav.toggle()"
			*ngIf="login && (device === 'tablet' || device === 'handset')"
			mat-icon-button
			id="mat-menu-button"
		>
			<mat-icon>menu</mat-icon>
		</button>
		<!-- <span style="font-size:24px;font-weight:900;color:#c3a151;">AIGIA</span> -->
		<span style="width: 100px">
			<img
				data-idtest="aigia-a-4Ve"
				alt="aigiaアプリ"
				src="/images/logo.svg"
			/>
		</span>
	</div>
	<div
		*ngIf="login && device !== 'handset'"
		fxLayout="row"
		fxLayoutAlign="space-around center"
	>
		<span
			data-idtest="aigia-t-3Cu"
			style="
				color: #b1c256;
				font-size: 10px;
				font-weight: 900;
				margin: 0 8px;
			"
			*ngIf="isSubscribe || isAccounting"
			translate
			>入会済み</span
		>
		<span
			data-idtest="aigia-t-0Pi"
			style="
				color: #eb412a;
				font-size: 10px;
				font-weight: 900;
				margin: 0 8px;
			"
			*ngIf="!isSubscribe && !isAccounting"
			translate
			>未入会</span
		>
		<span
			data-idtest="aigia-t-2Bd"
			style="color: #e8e8e8; font-size: 14px; margin: 0 8px"
			>{{ currentSession.content.nickname }}</span
		>
		<span
			data-idtest="aigia-t-0Pe"
			style="color: #c1c1c1; font-size: 10px; margin: 0 8px"
			>[{{ currentSession.username }}]</span
		>
		<button
			(complete)="onLogout($event)"
			aigia-logout-button
			[params]="params"
			mat-button
			id="mat-header-logout-button-1"
		>
			<div fxLayout="row" fxLayoutAlign="center center">
				<mat-icon
					class="header-menu-icon"
					style="
						padding-left: 4px;
						font-size: 8px;
						display: block;
						height: auto;
					"
					>exit_to_app</mat-icon
				>
				<span data-idtest="aigia-t-7Di" style="display: block" translate
					>ログアウト</span
				>
			</div>
		</button>
		<button
			data-idtest="aigia-b-9Yc"
			aigia-login-qr-button
			mat-button
			style="color: #fdfdfd; font-size: 12px"
			id="mat-header-qr-code-button-1"
		>
			<div fxLayout="row" fxLayoutAlign="center center">
				<mat-icon
					class="header-menu-icon"
					style="
						padding-left: 4px;
						font-size: 8px;
						display: block;
						height: auto;
					"
					>center_focus_strong</mat-icon
				>
				<span data-idtest="aigia-t-7Xy" style="display: block" translate
					>QR Code</span
				>
			</div>
		</button>

		<!--	<button contact-button mat-button style="color:#fdfdfd;font-size:12px;" [username]="currentSession.username">
			<div fxLayout="row" fxLayoutAlign="center center">
				<span style="display: block;" translate>contact</span>
			</div>
		</button> -->

		<select
			class="lang-select"
			style="margin-top: 4px"
			#langSelect
			(change)="setLanguage(langSelect.value)"
		>
			<option
				*ngFor="let lang of translate.getLangs()"
				[value]="lang"
				[selected]="lang === translate.currentLang"
			>
				{{ langToName(lang) }}
			</option>
		</select>
	</div>
	<div
		*ngIf="login && device === 'handset'"
		fxLayout="row"
		fxLayoutAlign="space-around center"
		style="justify-content: space-between; width: calc(min(230px, 55%))"
	>
		<div *ngIf="!isSubscribe && !isAccounting" fxLayout="column">
			<span
				style="
					color: #e8e8e8;
					font-size: 0.8rem;
					font-weight: 900;
					margin: 2px 0px;
					line-height: 14px;
				"
				>{{ currentSession.content.nickname }}</span
			>
			<span
				data-idtest="aigia-t-6Yr"
				style="
					color: #eb412a;
					font-size: 0.6rem;
					font-weight: 900;
					margin: 2px 0px;
					line-height: 14px;
				"
				translate
				>未入会</span
			>
		</div>
		<div *ngIf="isSubscribe || isAccounting" fxLayout="column">
			<span
				style="
					color: #b2c941;
					font-size: 0.8rem;
					font-weight: 900;
					margin: 2px 0px;
					line-height: 14px;
				"
				>{{ currentSession.content.nickname }}</span
			>
			<span
				data-idtest="aigia-t-4Zf"
				style="
					color: #b1c256;
					font-size: 0.6rem;
					font-weight: 900;
					margin: 2px 0px;
					line-height: 14px;
				"
				translate
				>入会済み</span
			>
		</div>
		<button
			(complete)="onLogout($event)"
			aigia-logout-button
			[params]="params"
			mat-button
			id="mat-header-logout-button-2"
			class="mobile-minwidth"
		>
			<div fxLayout="row" fxLayoutAlign="center center">
				<mat-icon
					class="header-menu-icon"
					style="font-size: 18px; display: block; height: auto"
					>exit_to_app</mat-icon
				>
			</div>
		</button>
		<button
			aigia-login-qr-button
			mat-button
			style="color: #fdfdfd; font-size: 12px"
			id="mat-header-qr-code-button-2"
			class="mobile-minwidth"
		>
			<div fxLayout="row" fxLayoutAlign="center center">
				<mat-icon
					class="header-menu-icon"
					style="font-size: 18px; display: block; height: auto"
					>center_focus_strong</mat-icon
				>
			</div>
		</button>

		<select
			class="lang-select"
			#langSelect
			(change)="setLanguage(langSelect.value)"
		>
			<option
				*ngFor="let lang of translate.getLangs()"
				[value]="lang"
				[selected]="lang === translate.currentLang"
			>
				{{ langToName(lang) }}
			</option>
		</select>
	</div>
	<div *ngIf="!login" fxLayout="row" fxLayoutAlign="center center">
		<select
			class="lang-select"
			#langSelect
			(change)="setLanguage(langSelect.value)"
		>
			<option
				*ngFor="let lang of translate.getLangs()"
				[value]="lang"
				[selected]="lang === translate.currentLang"
			>
				{{ langToName(lang) }}
			</option>
		</select>
	</div>
</mat-toolbar>
<mat-sidenav-container [class.dark-theme]="true" class="container">
	<mat-sidenav
		#sidenav
		[mode]="device === 'tablet' || device === 'handset' ? 'over' : 'side'"
		[opened]="!(device === 'tablet' || device === 'handset') && login"
		class="sidenav-background"
		style="border-right-color: #484a5b; width: 227px"
	>
		<div fxLayout="column" fxLayoutAlign="space-between" fxFill>
			<mat-list>
				<mat-list-item
					class="side-menu-item"
					[ngClass]="side('/shotdata')"
				>
					<a
						data-idtest="aigia-b-8Ou"
						mat-button
						class="side-menu-text"
						(click)="
							device === 'tablet' || device === 'handset'
								? !sidenav.toggle()
								: null
						"
						[queryParams]="params"
						routerLink="/shotdata"
					>
						<mat-icon
							data-idtest="aigia-a-6Mz"
							class="side-menu-icon"
							mat-list-icon
							>golf_course</mat-icon
						>
						<span data-idtest="aigia-t-1Vm" translate
							>スイングチェック</span
						>
					</a>
				</mat-list-item>
				<mat-list-item
					class="side-menu-item"
					*ngIf="authIs('studio') || isSubscribe || isAccounting"
					[ngClass]="side('/staticvideo')"
				>
					<a
						data-idtest="aigia-b-7Fz"
						mat-button
						class="side-menu-text"
						(click)="
							device === 'handset' ? !sidenav.toggle() : null
						"
						[queryParams]="params"
						routerLink="/staticvideo"
					>
						<mat-icon
							data-idtest="aigia-a-5Of"
							class="side-menu-icon"
							mat-list-icon
							>videocam</mat-icon
						>
						<span data-idtest="aigia-t-0Bh" translate
							>レッスン動画一覧</span
						>
					</a>
				</mat-list-item>
				<mat-list-item class="side-menu-item" [ngClass]="side('/home')">
					<a
						data-idtest="aigia-b-1Ph"
						mat-button
						class="side-menu-text"
						(click)="
							device === 'tablet' || device === 'handset'
								? !sidenav.toggle()
								: null
						"
						[queryParams]="params"
						routerLink="/home"
					>
						<mat-icon
							data-idtest="aigia-a-5Fa"
							class="side-menu-icon"
							mat-list-icon
							>vpn_key</mat-icon
						>
						<span data-idtest="aigia-t-7Dy" translate
							>会員情報</span
						>
					</a>
				</mat-list-item>
				<!--	<mat-list-item class="side-menu-item" [ngClass]="side('/news')">
					<a mat-button class="side-menu-text" (click)="(device === 'tablet' || device === 'handset') ? !sidenav.toggle(): null" [queryParams]="params" routerLink="/news">
						<mat-icon data-idtest="aigia-a-2It" class="side-menu-icon" mat-list-icon>done</mat-icon>
						<span data-idtest="aigia-t-3Li" translate>お知らせ</span>
					</a>
				</mat-list-item> -->
				<mat-list-item class="side-menu-item">
					<a
						mat-button
						class="side-menu-text"
						href="https://aigia.co.jp/studio-list"
						target="_blank"
						rel="noopener noreferrer"
					>
						<mat-icon
							data-idtest="aigia-a-9Kk"
							class="side-menu-icon"
							mat-list-icon
							>shop</mat-icon
						>
						<span data-idtest="aigia-t-3Jm" translate
							>AIGIA導入店舗</span
						>
					</a>
				</mat-list-item>
				<mat-list-item
					class="side-menu-item"
					*ngIf="authEq('studio') || authIs('manager')"
					[ngClass]="side('/guests2')"
				>
					<a
						data-idtest="aigia-b-5Tg"
						mat-button
						class="side-menu-text"
						(click)="
							device === 'tablet' || device === 'handset'
								? !sidenav.toggle()
								: null
						"
						[queryParams]="params"
						routerLink="/guests2"
						data-test="guests2"
					>
						<mat-icon
							data-idtest="aigia-a-3Yd"
							class="side-menu-icon"
							mat-list-icon
							>people</mat-icon
						>
						<span data-idtest="aigia-t-8Rn" translate
							>会員管理</span
						>
					</a>
				</mat-list-item>
			</mat-list>
			<div
				data-idtest="aigia-t-9Iw"
				style="color: #be8b4d; font-size: 6px; margin-bottom: 4px"s
				fxLayout="row"
				fxLayoutAlign="center"
			>
				v3.3.0
			</div>
		</div>
	</mat-sidenav>
	<mat-sidenav-content
		style="background: linear-gradient(150deg, #242424, #141414)"
	>
		<div [@fadeAnimation]="prepareRoute(outlet)">
			<router-outlet #outlet="outlet"></router-outlet>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
